import { render, staticRenderFns } from "./TourDashboard.vue?vue&type=template&id=7950c322&scoped=true&"
import script from "./TourDashboard.vue?vue&type=script&lang=js&"
export * from "./TourDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7950c322",
  null
  
)

export default component.exports